import { DropTarget, updateLayoutValues } from './utils';
import { getDropTargetStyle } from './getDropTargetStyle';

export const updateDropTarget = (
  dropTarget: DropTarget,
  currentX: number,
  currentY: number
) => {
  if (dropTarget.currentX === currentX && dropTarget.currentY === currentY) {
    return;
  }
  if (dropTarget.isDragTarget) {
    updateLayoutValues(dropTarget, currentX, currentY);
    return;
  }
  updateLayoutValues(dropTarget, currentX, currentY);
  const componentStyle = getDropTargetStyle(
    dropTarget.translateX,
    dropTarget.translateY
  );
  dropTarget.setStateWithRefCheck({ componentStyle });
};
